import React from 'react';
import customerImg from '../images/aboutimages/739.png'

const CustomerDetailsDashboard = () => {
    // Static data for a single customer
    const customer = {
        name: 'Sangeetha',
        email: 'john.doe@example.com',
        phone: '+1 123-456-7890',
        address: '123 Elm Street, Springfield, IL',
        totalSpent: 1355,
        monthlySpending: {
            January: 1200,
            February: 105,
            March: 50,
        },
        purchasedProducts: [
            {
                id: 1,
                name: 'Cotton Sarees',
                quantity: 1,
                price: 1200,
                date: '2024-01-15',
                image: 'https://images.unsplash.com/photo-1609748341932-f0206c09412b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDl8fHxlbnwwfHx8fHw%3D',
            },
            {
                id: 2,
                name: 'Silk Saree',
                quantity: 1,
                price: 25,
                date: '2024-02-20',
                image: 'https://images.unsplash.com/photo-1609748340756-aeb8223d6c64?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDEwfHx8ZW58MHx8fHx8',
            },
            {
                id: 3,
                name: 'Hydrabad Saree',
                quantity: 1,
                price: 80,
                date: '2024-02-25',
                image: 'https://images.unsplash.com/photo-1610189337543-1c5d8e64f574?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDV8fHxlbnwwfHx8fHw%3D',
            },
            {
                id: 4,
                name: 'Kerala Saree',
                quantity: 2,
                price: 50,
                date: '2024-03-10',
                image: 'https://images.unsplash.com/photo-1610030469668-8e9f641aaf27?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fHw%3D',
            },
        ],
    };

    return (
        <div className="bg-gray-100 min-h-screen p-8">
            {/* Header */}
            <div className="mb-6">
                <h1 className="text-3xl font-bold text-gray-800">Customer Dashboard</h1>
                <p className="text-gray-600">Details and purchase history for {customer.name}</p>
            </div>

            {/* Overview Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white  rounded-lg p-6">
                    <h2 className="text-gray-700 text-lg font-semibold">Total Spent</h2>
                    <p className="text-2xl font-bold text-green-600">${customer.totalSpent}</p>
                </div>
                <div className="bg-white  rounded-lg p-6">
                    <h2 className="text-gray-700 text-lg font-semibold">Monthly Spending</h2>
                    <ul>
                        {Object.entries(customer.monthlySpending).map(([month, amount]) => (
                            <li key={month} className="text-gray-600">
                                {month}: <span className="text-gray-800 font-semibold">${amount}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="bg-white  rounded-lg p-6">
                    <h2 className="text-gray-700 text-lg font-semibold">Contact Information</h2>
                    <div className='flex gap-8  py-10'>
                        <div className=''>
                            <img src={customerImg} className='w-[100px] h-[100px] object-cover object-top rounded-full' alt='customerImage' />
                        </div>
                        <div className='flex flex-col gap-3'>

                            <p>{customer.name}</p>
                            <p>{customer.email}</p>
                            <p>{customer.phone}</p>
                            <p>{customer.address}</p>
                        </div>

                    </div>
                </div>
            </div>

            {/* Purchased Products */}
            <div className="bg-white  rounded-lg p-6">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Purchased Products</h2>
                <div className="grid grid-cols-1 md:grid-cols-3  gap-6">
                    {customer.purchasedProducts.map((product) => (
                        <div
                            key={product.id}
                            className="bg-gray-50 border gap-4 border-gray-200 rounded-lg shadow-sm p-4 flex"
                        >
                            <img
                                src={product.image}
                                alt={product.name}
                                className="h-32 w-40 object-center  object-cover rounded-lg mb-4"
                            />
                            <div>

                                <h3 className="text-gray-800 font-semibold text-lg">
                                    {product.name}
                                </h3>
                                <p className="text-gray-600">Quantity: {product.quantity}</p>
                                <p className="text-gray-600">Price: ${product.price}</p>
                                <p className="text-gray-600">
                                    Purchase Date: {new Date(product.date).toLocaleDateString()}
                                </p>
                                <p className="text-gray-800 font-bold">
                                    Total: ${product.quantity * product.price}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CustomerDetailsDashboard;
